// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-text {
  width: 100%;
}

.dropdown-text__container {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: var(--secondary-color);
  border-radius: 8px;
  color: var(--web-primary-color);
  cursor: pointer;
}
.dropdown-text__container span {
  color: var(--accent-color);
}
.dropdown-text__container:hover {
  background-color: var(--secondary-color-hover);
}
.dropdown-text__container:active, .dropdown-text__container.active {
  background-color: var(--secondary-color-pressed);
}

.dropdown-text__label {
  text-align: start;
}

.dropdown__indicator {
  display: flex;
  transform: rotate(-90deg);
}
.dropdown__indicator.open {
  transform: rotate(0deg);
}

.dropdown-text__text-container {
  background-color: var(--white-color);
}
.dropdown-text__text-container > div {
  max-width: 1210px;
}

@media only screen and (min-device-width: 320px) {
  .dropdown-text__container {
    padding: 16px;
  }
  .dropdown-text__text-container {
    padding-top: 16px;
  }
  .dropdown__indicator svg {
    width: 24px;
    height: 24px;
  }
}
@media only screen and (min-device-width: 768px) {
  .dropdown-text__container {
    padding: 24px 32px;
  }
  .dropdown-text__text-container {
    padding-top: 24px;
  }
  .dropdown__indicator svg {
    width: 24px;
    height: 24px;
  }
}
@media only screen and (min-device-width: 992px) {
  .dropdown-text__container {
    padding: 36px 42px;
  }
  .dropdown-text__text-container {
    padding-top: 24px;
  }
  .dropdown__indicator svg {
    width: 24px;
    height: 24px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .dropdown-text__container {
    padding: 36px 42px;
  }
  .dropdown-text__text-container {
    padding-top: 24px;
  }
  .dropdown__indicator svg {
    width: 36px;
    height: 36px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DropdownText/dropdownText.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AACA;EACE,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;AAEF;AADE;EACE,0BAAA;AAGJ;AADE;EACE,8CAAA;AAGJ;AADE;EACE,gDAAA;AAGJ;;AAAA;EACE,iBAAA;AAGF;;AADA;EACE,aAAA;EACA,yBAAA;AAIF;AAHE;EACE,uBAAA;AAKJ;;AAFA;EACE,oCAAA;AAKF;AAJE;EACE,iBAAA;AAMJ;;AAFA;EACE;IACE,aAAA;EAKF;EAHA;IACE,iBAAA;EAKF;EAHA;IACE,WAAA;IACA,YAAA;EAKF;AACF;AAFA;EACE;IACE,kBAAA;EAIF;EAFA;IACE,iBAAA;EAIF;EAFA;IACE,WAAA;IACA,YAAA;EAIF;AACF;AADA;EACE;IACE,kBAAA;EAGF;EADA;IACE,iBAAA;EAGF;EADA;IACE,WAAA;IACA,YAAA;EAGF;AACF;AAAA;EACE;IACE,kBAAA;EAEF;EAAA;IACE,iBAAA;EAEF;EAAA;IACE,WAAA;IACA,YAAA;EAEF;AACF","sourcesContent":[".dropdown-text{\n  width: 100%;\n}\n.dropdown-text__container{\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  background-color: var(--secondary-color);\n  border-radius: 8px;\n  color: var(--web-primary-color);\n  cursor: pointer;\n  span {\n    color: var(--accent-color);\n  }\n  &:hover{\n    background-color: var(--secondary-color-hover);\n  }\n  &:active, &.active{\n    background-color: var(--secondary-color-pressed);\n  }\n}\n.dropdown-text__label{\n  text-align: start;\n}\n.dropdown__indicator {\n  display: flex;\n  transform: rotate(-90deg);\n  &.open {\n    transform: rotate(0deg);\n  }\n}\n.dropdown-text__text-container{\n  background-color: var(--white-color);\n  & > div {\n    max-width: 1210px;\n  }\n}\n\n@media only screen and (min-device-width: 320px) {\n  .dropdown-text__container{\n    padding: 16px;\n  }\n  .dropdown-text__text-container{\n    padding-top: 16px;\n  }\n  .dropdown__indicator svg{\n    width: 24px;\n    height: 24px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .dropdown-text__container{\n    padding: 24px 32px;\n  }\n  .dropdown-text__text-container{\n    padding-top: 24px;\n  }\n  .dropdown__indicator svg{\n    width: 24px;\n    height: 24px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .dropdown-text__container{\n    padding: 36px 42px;\n  }\n  .dropdown-text__text-container{\n    padding-top: 24px;\n  }\n  .dropdown__indicator svg{\n    width: 24px;\n    height: 24px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .dropdown-text__container{\n    padding: 36px 42px;\n  }\n  .dropdown-text__text-container{\n    padding-top: 24px;\n  }\n  .dropdown__indicator svg{\n    width: 36px;\n    height: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
